// Campus photo for /colleges/colgate-university: CC0 1.0, by Balon Greyjoy, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AColgate_University_Across_Taylor_Lake.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/colgate-university/; credited under the photo.
const photo = {
    "slug": "colgate-university",
    "alt": "Colgate University buildings on the hill seen across Taylor Lake in Hamilton, New York",
    "src": "/colleges/colgate-university/campus-1600.webp",
    "srcSmall": "/colleges/colgate-university/campus-800.webp",
    "srcMid": "/colleges/colgate-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/colgate-university/og.jpg",
    "title": "Colgate University Across Taylor Lake",
    "author": "Balon Greyjoy",
    "license": "CC0 1.0",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AColgate_University_Across_Taylor_Lake.jpg",
    "read": "2026-10-01"
};

export default photo;
